import {createStore} from 'redux';
import {getAllReducers} from 'Store/reducer';

export const getStore = (initialState = {}) => createStore(
    getAllReducers(),
    initialState
);

export const axaStore = getStore();
